import { useSnackbar } from "notistack";
import { APIsContext } from "../../Store/APIs/context";
import { useContext, useState } from "react";
import { AccountRole } from "../../Store/Accounts/types";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, styled, TextField } from "@mui/material";
import DialogTitleClose from "../Misc/Dialog/Components/DialogTitleClose";
import GridContainer from "../Filter/Components/grid/GridContainer";
import ButtonLightGray from "../Filter/Components/ButtonLightGray";
import ButtonGradient from "../Filter/Components/ButtonGradient";
import { CreateAccountRequest } from "neurotec-megamatcherid-management-client";
import DialogTypographyTitle from "../Misc/Dialog/Components/DialogTypographyTitle";

const SelectType = styled(Select)({
    padding: "none",
})

interface AddAccountDialogProps {
    open: boolean,
    onClose: (bool: boolean) => void,
    rerender: () => void
}

const AddAccountDialog: React.FC<AddAccountDialogProps> = (props) => {

    const { enqueueSnackbar } = useSnackbar();
    const [usernameError, setUsernameError] = useState(false)
    const [passwordError, setPasswordError] = useState(false)
    const { state } = useContext(APIsContext)

    const handleOnClose = () => {
        props.onClose(false)
    }

    const handleExit = () => {
        setUsernameError(false)
        setPasswordError(false)
    }

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        const username = new FormData(event.currentTarget).get("account-username") as string;
        const password = new FormData(event.currentTarget).get("account-password") as string;
        const passwordConfirm = new FormData(event.currentTarget).get("account-password-confirm") as string;
        const role = new FormData(event.currentTarget).get("account-role") as AccountRole;

        if ((username === null || username === "")) {
            enqueueSnackbar("Username must not be blank", {variant: "warning"})
            setUsernameError(true)
            return
        } else {
            setUsernameError(false)
        }
        
        if ((password === null || password === "")) {
            enqueueSnackbar("Password must not be blank", {variant: "warning"})
            setPasswordError(true)
            return
        } else {
            setPasswordError(false)
        }

        if (password !== passwordConfirm) {
            enqueueSnackbar("Passwords must match", {variant: "warning"})
            setPasswordError(true)
            return
        }
        
        const request: CreateAccountRequest = {
            username,
            password,
            role
        }
        state.AccountsApi.createAccount({createAccountRequest: request}).then(res => {
            if (res.status === 200) {
                enqueueSnackbar("Account created successfully", { variant: 'success' });
                props.rerender();
            } else {
                enqueueSnackbar("Failed to create account", { variant: 'error' });
            }
        }).catch(err => {
            console.log(err.message)
            enqueueSnackbar(err.message, { variant: 'error' });
            return
        })
        handleOnClose()
    }
    
    return (
        <Dialog
            maxWidth="xs"
            scroll="body"
            fullWidth
            open={props.open}
            onClose={handleOnClose}
            onTransitionExited={handleExit}
        >
            <Box component="form" onSubmit={handleSubmit} noValidate >
                <DialogTitle>
                    <DialogTitleClose title={"Create account"} onClose={handleOnClose}/>
                </DialogTitle>
                <DialogContent style={{paddingBottom: "0px"}}>
                    <GridContainer container style={{paddingTop: "0rem"}}>
                        <DialogTypographyTitle>Username*</DialogTypographyTitle>
                        <TextField
                            sx={{margin: "none"}}
                            style={{paddingBottom: "0.75rem"}}
                            autoComplete="one-time-code"
                            id="account-username"
                            name="account-username"
                            placeholder="Username"
                            inputProps={{
                                style: {paddingBottom: "0.5rem"}
                            }}
                            InputLabelProps={{
                                sx: {top: "-7px", "&.MuiInputLabel-shrink": {top: "0px"}},
                            }}
                            error={usernameError}
                        />
                        <DialogTypographyTitle>Password*</DialogTypographyTitle>
                        <TextField
                            sx={{margin: "none"}}
                            style={{paddingBottom: "0.75rem"}}
                            autoComplete="one-time-code"
                            id="account-password"
                            name="account-password"
                            placeholder="Password"
                            type="password"
                            inputProps={{
                                style: {paddingBottom: "0.5rem"}
                            }}
                            InputLabelProps={{
                                sx: {top: "-7px", "&.MuiInputLabel-shrink": {top: "0px"}},
                            }}
                            error={passwordError}
                        />
                        <DialogTypographyTitle>Confirm password*</DialogTypographyTitle>
                        <TextField
                            sx={{margin: "none"}}
                            style={{paddingBottom: "0.75rem"}}
                            autoComplete="one-time-code"
                            id="account-password-confirm"
                            name="account-password-confirm"
                            placeholder="Confirm password"
                            type="password"
                            inputProps={{
                                style: {paddingBottom: "0.5rem"}
                            }}
                            InputLabelProps={{
                                sx: {top: "-7px", "&.MuiInputLabel-shrink": {top: "0px"}},
                            }}
                            error={passwordError}
                        />
                        <DialogTypographyTitle>Role*</DialogTypographyTitle>
                        <SelectType
                            id={"account-role"}
                            name={"account-role"}
                            defaultValue={AccountRole.USER}
                            style={{width: "100%", marginBottom: "0.75rem"}}
                            MenuProps={{MenuListProps: {disablePadding: true}}}
                        >
                            <MenuItem value={AccountRole.ADMIN}>Admin</MenuItem>
                            <MenuItem value={AccountRole.USER}>User</MenuItem>
                            <MenuItem value={AccountRole.ADJUDICATOR}>Adjudicator</MenuItem> 
                        </SelectType>
                    </GridContainer>
                </DialogContent>
                <DialogActions>
                    <ButtonLightGray onClick={handleOnClose}>
                        Cancel
                    </ButtonLightGray>
                    <ButtonGradient variant="contained" color="primary" type='submit'>
                        Create account
                    </ButtonGradient>
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default AddAccountDialog;